export default __webpack_public_path__ + "static/media/icon_facility_toilet.4de3276d.svg";